// removed by extract-text-webpack-plugin
module.exports = {"heading":"_1Mrh8jduDjm0kA9TRb3iPv","small":"_3jSQn4jTun1pxot9n9S-nO","block-wrapper":"_2Se63j5c7hCjGPEMxXh3C5","contacts":"tsH3cUnceVBE6nAHcuyQS","circle":"_2bq753ztGbYUyEBaUG5J8H","circle-large":"E4mRiCNgTc50oAniO0Zhi","person-block":"_3MUFuyeAo3bq3H0EiY9D94","left-aligned":"t9HbfD4DRKhZ7GKe3CWkP","info":"_3WKctNLs1PjJboy4YxdYpN","name":"_20sZq49X0p3xE16AQWp_xm","title":"_1gVmSMtB6Uop4XXTkenaou","department":"_3xVpirxUY22WYtdnaILxCk","contact-info":"_3eKeFt8GK4NaLk19zUMK5F","no-image":"_32BavEoJgfbe9E3nk7uk5t","detailed-info":"VXbp2M1Lukr_loREdCRKB","see-all-link":"_2-lhLTOQmWksApOlh-RZwX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactBlock/ContactBlock.module.scss
// module id = 742
// module chunks = 0